<template>
    <div v-cloak>
        <load-spinner :loading="isLoading" />

        <b-nav
            fill
            pills
            class="my-4"
        >
        <b-nav-item
            :active="level === 1"
            :to="link(1)"
        >
            <h4>
                <b>
                    Level 1 <b-badge v-text="levelCount(1)" />
                </b>
            </h4>
        </b-nav-item>
        <b-nav-item
            :active="level === 2"
            :to="link(2)"
        >
            <h4>
                <b>
                    Level 2 <b-badge v-text="levelCount(2)" />
                </b>
            </h4>
        </b-nav-item>
        <b-nav-item
            :active="level === 3"
            :to="link(3)"
        >
            <h4>
                <b>
                    Level 3 <b-badge v-text="levelCount(3)" />
                </b>
            </h4>
        </b-nav-item>
        <b-nav-item
            :active="level === 4"
            :to="link(4)"
        >
            <h4>
                <b>
                    Level 4 <b-badge v-text="levelCount(4)" />
                </b>
            </h4>
        </b-nav-item>
        </b-nav>

        <b-card no-body>
            <b-row>
                <b-col class="my-2 mx-2">
                    <b-form-group
                        label-cols-md="3"
                        label="Unit Code or Title:"
                    >
                        <b-input-group>
                            <b-form-input
                                v-model="filter"
                                placeholder="Type to Search"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="filter = ''"
                                >
                                    Clear
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="p-4">
                <part-one-component
                    :student="student"
                    :competencies="filteredCompetencies"
                    :enrolments="enrolments"
                    :enrolment-details="enrolmentDetails[0]"
                    :teachers="teachers"
                    :read-only="true"
                    :hyperlinks="hyperlinks"
                    @refreshData="refreshData"
                />
            </div>

            <b-row>
                <b-col class="my-2 mx-2">
                    <b-form-checkbox
                        v-model="showOldcourse"
                        :value="1"
                        :unchecked-value="0"
                    >
                        {{ showOldcourse ? 'Hide' : 'Show' }} Old Course
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
/* global _ */
/* global Noty */
/* global axios */
import PartOneComponent from './PartOneComponent.vue';
import PartTwoComponent from './PartTwoComponent.vue';
import StudentStatisticsComponent from './StudentStatisticsComponent.vue';

export default {
    name: 'StudentLevels',
    components: {
        PartOneComponent,
        PartTwoComponent,
        StudentStatisticsComponent,
    },
    props: {
        student: {
            type: Object,
            required: true,
        },
        hyperlinks: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
            showOldcourse: 0,
            filter: null,
            enrolments: [],
            enrolmentDetails: [],
            teachers: [],
            mentors: [],
        };
    },
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
        competencies() {
            return this.enrolments.filter(enrolment => Number(enrolment.level) === Number(this.level)
                && enrolment.enrol_type === 'C'
                && Number(enrolment.old_course) <= Number(this.showOldcourse));
        },
        filteredCompetencies() {
            if (this.filter) {
                return this.competencies.filter(enrolment => enrolment.code.toLowerCase().includes(this.filter.toLowerCase())
                    || enrolment.title.toLowerCase().includes(this.filter.toLowerCase()));
            }
            return this.competencies;
        },
        competenciesPart2() {
            return this.filteredCompetencies.filter(enrolment => enrolment.delivery_type.includes(2)
                || enrolment.delivery_type.includes(3));
        },
    },
    watch: {
        $route() {
            document.title = `Level ${this.level}`;
        },
        level() {
            this.fetchEnrolmentDetails();
        },
    },
    mounted() {
        this.fetchTeachers();
        this.fetchMentors();
        this.fetchEnrolments();
        this.fetchEnrolmentDetails();
    },

    methods: {
        refreshData() {
            this.fetchEnrolments();
            this.fetchEnrolmentDetails();
        },
        fetchEnrolments() {
            this.isLoading = true;

            const loaders = [
                'assessor',
                'trainer',
                'mentor',
                'personResponsible',
                'enrolmentAttachments',
                'enrolmentAttachments.comments',
                'enrolmentAttachments.comments.createdBy',
                'enrolmentAttachments.feedbackBy',
                'enrolmentAttachments.finalAssessmentBy',
                'assessmentToolLinkable'
            ].join(',');

            axios
                .get('/api/enrolments', {
                    params: {
                        student_id: this.student.id,
                        course_id: this.student.course_id,
                        level: this.level,
                        load: loaders,
                    },
                })
                .then((response) => {
                    response.data.data.forEach((el, index) => {
                        if (
                            el.banner_result !== ''
                            && el.result !== 'ATT' // there is no banner equivalent
                            && ((el.banner_result === 'CA' && el.result !== 'COM') || (el.banner_result === 'GCA' && el.result !== 'GCA') || (el.banner_result === 'PO' && el.result !== 'PO'))
                        ) {
                            /* eslint-disable-next-line */
                            response.data.data[index]._cellVariants = { banner_result: 'warning' };
                        }
                    });
                    this.enrolments = response.data.data;
                    this.isLoading = false;
                })
                .catch((error) => {
                    new Noty({
                        text: _.isUndefined(error.response)
                            ? error.message
                            : error.response.data.errors,
                        type: 'error',
                        timeout: 1000,
                    }).show();
                });
        },
        fetchEnrolmentDetails() {
            this.isLoading = true;
            axios
                .get('/api/enrolmentDetail', {
                    params: {
                        banner_id: this.student.banner_id,
                        course_id: this.student.course_id,
                        level: this.level,
                    },
                })
                .then((response) => {
                    //  remove blank teachers
                    this.enrolmentDetails = response.data.data;
                    this.isLoading = false;
                })
                .catch((error) => {
                    const n = new Noty({
                        text: error.response.data.message,
                        type: 'error',
                    });
                    n.show();
                });
        },
        fetchTeachers() {
            this.isLoading = true;
            axios
                .get('/api/teachersInDepartment', {
                    params: {
                        departmentId: this.student.department_id,
                    },
                })
                .then((response) => {
                    //  remove blank teachers
                    this.teachers = response.data.data.filter(el => el.name !== ' ');
                    this.isLoading = false;
                })
                .catch((error) => {
                    const n = new Noty({
                        text: error.response.data.message,
                        type: 'error',
                    });
                    n.show();
                });
        },
        fetchMentors() {
            this.isLoading = true;
            axios
                .get('/api/workplace-mentors', {
                    params: {
                        banner_id: this.student.banner_id,
                        course_id: this.student.course_id,
                    },
                })
                .then((response) => {
                    //  remove blank teachers
                    this.mentors = response.data.data.filter(el => el.name !== ' ');
                    this.isLoading = false;
                })
                .catch((error) => {
                    const n = new Noty({
                        text: error.response.data.message,
                        type: 'error',
                    });
                    n.show();
                });
        },
        levelCount(level) {
            return this.enrolments.filter(enrolment => enrolment.enrol_type === 'C'
                && enrolment.level.includes(level))
                .length;
        },
        levelCountTab2(level) {
            return this.enrolments.filter(enrolment => enrolment.enrol_type === 'C'
                && enrolment.level.includes(level)
                && (enrolment.delivery_type.includes(2)
                || enrolment.delivery_type.includes(3)))
                .length;
        },
        link(level) {
            return `/course/${this.student.course.courseCode}/level${level}`;
        },
    },
};
</script>
